import { Map } from 'immutable';
import { GET_TIERS_SUCCESS } from './TiersActionTypes';

const initialState = Map({
  tierList: [],
});

export default function TiersReducer(state = initialState, action) {
  switch (action.type) {
    case GET_TIERS_SUCCESS:
      return Map({
        ...state,
        tierList: action.response,
      });
    default:
      return state;
  }
}


